import ChecklistsLayout from '../components/layouts/ChecklistsLayout.vue';
import ChecklistsIndexPage from '../pages/ChecklistsIndexPage.vue';
import ChecklistTemplateShowPage from '../pages/ChecklistTemplateShowPage.vue';
import ChecklistTemplatesIndexPage from '../pages/ChecklistTemplatesIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    // This is the parent route for your package.
    // It uses the layout component.
    path: '/checklists',
    name: 'checklists.root',
    component: ChecklistsLayout,
    meta: {
      // e.g., requiresAuth: true
      // requiresAuth: true,
      // title: 'checklists.nav.title',
      layout: 'Authenticated',
    },
    // All other package routes are children of this layout
    children: [
      {
        // Child path is empty, so it renders at /checklists
        path: '',
        name: 'ChecklistsIndexPage',
        component: ChecklistsIndexPage,
      },
      {
        path: 'templates',
        name: 'ChecklistTemplatesIndexPage',
        component: ChecklistTemplatesIndexPage,
      },
      {
        path: 'templates/:checklistTemplateId',
        name: 'ChecklistTemplateShowPage',
        component: ChecklistTemplateShowPage,
      },
      {
        path: 'templates/:checklistTemplateId/edit',
        name: 'ChecklistTemplateEditPage',
        component: ChecklistTemplateShowPage,
      },
      // --- Example of other child routes ---
      // {
      //   path: 'create', // Renders at /checklists/create
      //   name: 'checklists.create',
      //   component: () => import('../components/Create.vue'),
      // },
    ]
  }
];
